import { Checkbox, Col, Form, Modal, Row, Select } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getEnterpriseMemberList } from '../../api/constlink';

const { Option } = Select;

const StyledDiv = styled.div``;

interface UpdateFAModalProps {
  visible: boolean;
  isMyAsset: boolean;
  enterpriseId: string;
  data: any;
  onUpdate: (value: any) => void;
  onCancel: () => void;
}

function UpdateFAModal({
  visible,
  isMyAsset,
  enterpriseId,
  data,
  onUpdate,
  onCancel,
}: UpdateFAModalProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [memberList, setMemberList] = useState<any[]>();

  useEffect(() => {
    if (!mount) return;

    (async () => {
      const members = await getEnterpriseMemberList({ enterpriseId });
      let children: any = [];
      for (const member of members) {
        children.push(
          <Option key={member.id} value={member.id}>
            {member.name}
          </Option>,
        );
      }
      setMemberList(children);
    })();

    return () => setMount(false);
  }, [enterpriseId, mount]);

  return (
    <StyledDiv>
      <Modal
        visible={visible}
        title="카드정보 수정"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              onUpdate({ ...data, ...values });
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form form={form} initialValues={{ ...data }}>
            <Row justify={'center'}>
              <Col span={18}>
                <Form.Item
                  name="isConnected"
                  label="카드연동"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select style={{ width: '100%' }}>
                    <Option key="0" value={true}>
                      예
                    </Option>
                    <Option key="1" value={false}>
                      아니오
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {!isMyAsset && (
              <Row justify="center">
                <Col span={18}>
                  <Form.Item
                    name={['user', 'id']}
                    label="담당자"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select style={{ width: '100%' }}>{memberList}</Select>
                  </Form.Item>{' '}
                </Col>
              </Row>
            )}
            <Row justify="center">
              <Col span={18}>
                <Form.Item name="isRefund" valuePropName="checked">
                  <Checkbox style={{ width: '100%' }}>경비 환급</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default UpdateFAModal;
